"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SalesByCategorySummaryData_1 = __importDefault(require("../entity/SalesByCategorySummaryData"));
const SalesByCategorySummaryStub_1 = __importDefault(require("./SalesByCategorySummaryStub"));
class SalesByCategorySummaryDataStub extends SalesByCategorySummaryData_1.default {
    constructor({ label = 'Test', summaries = [new SalesByCategorySummaryStub_1.default(), new SalesByCategorySummaryStub_1.default()], } = {}) {
        super({ label, summaries });
    }
}
exports.default = SalesByCategorySummaryDataStub;
